import * as Yup from 'yup';

export const add = Yup.object().shape({
    app_name: Yup.string().required('Application Name is required'),
    description: Yup.string().required('Description is required'),
});
